import { useSelector } from 'react-redux';
import { AppMode } from 'store/Common/reducers/common';
import { IRootReducerState } from 'store/store';

// Show net prices if not blueprint/dealerPanel mode or if isUsingSupplierSystemDiscounts while in blueprint/dealerPanel mode
export const useShouldShowSpecificPrices = (): {
  showNet: boolean;
  showGross: boolean;
  isUsingSupplierSystemDiscounts: boolean;
  canEditPricing: boolean;
} => {
  const appMode: AppMode = useSelector(
    (state: IRootReducerState) => state.commonInfo.appMode
  );
  const isUsingSupplierSystemDiscounts: boolean = useSelector(
    (state: IRootReducerState) => state.modelInfo.isUsingSupplierSystemDiscounts
  );

  const enableNetPrice: boolean = useSelector(
    (state: IRootReducerState) => state.userInfo?.intent?.enable_net_price
  );

  const enableEditPricing: boolean = useSelector(
    (state: IRootReducerState) =>
      state.userInfo?.intent?.enable_edit_pricing ?? false
  );

  if ([AppMode.BUYER, AppMode.SUPPLIER].includes(appMode)) {
    return {
      showNet: true,
      showGross: true,
      isUsingSupplierSystemDiscounts,
      canEditPricing: appMode === AppMode.SUPPLIER,
    };
  }
  if (isUsingSupplierSystemDiscounts) {
    return {
      showNet: true,
      showGross: enableNetPrice,
      isUsingSupplierSystemDiscounts,
      canEditPricing: enableEditPricing,
    };
  } else {
    return {
      showNet: enableNetPrice,
      showGross: true,
      isUsingSupplierSystemDiscounts,
      canEditPricing: enableEditPricing,
    };
  }
};
